import { Link, TableRow, TableSection } from '@solvhealth/jigsaw-v1';
import React, { PureComponent } from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import { isEmpty } from '../../../../core/util/empty';
import { SectionContentItem } from '~/components/Paperwork/interfaces';

type OwnProps = {
  allFields: SectionContentItem[];
  handleOnClick?: () => void;
  sectionTitle: string;
  showEditButton?: boolean;
  t: TFunction<'common'>;
};

type Props = OwnProps & typeof FinalizeCard.defaultProps;

class FinalizeCard extends PureComponent<Props> {
  static defaultProps = {
    showEditButton: true,
  };

  renderContent = () => {
    let displayContent = [];

    for (let field = 0; field < this.props.allFields.length; field++) {
      let currentKey = null;
      let currentTitle = null;
      let currentValue = null;
      for (const fieldKey in this.props.allFields[field]) {
        if (this.props.allFields) {
          currentKey = fieldKey;

          if (isEmpty(currentKey)) {
            continue;
          }
          currentTitle = this.props.allFields[field][currentKey].displayName;
          currentValue = this.props.allFields[field][currentKey].value;
        }
      }

      displayContent.push(
        <TableRow key={`${currentKey}${currentValue}`} title={currentTitle} value={currentValue} />
      );
    }

    return displayContent;
  };

  render = () => {
    const { sectionTitle, showEditButton, handleOnClick } = this.props;

    const renderedContent = this.renderContent();

    if (!renderedContent.length) {
      return null;
    }

    return (
      <TableSection
        accessory={
          showEditButton && (
            <Link onClick={handleOnClick}>{this.props.t('edit').toLocaleLowerCase()}</Link>
          )
        }
        title={sectionTitle}
      >
        {renderedContent}
      </TableSection>
    );
  };
}

export default withTranslation('common')(FinalizeCard);
